import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./DashboardBanner.css";

const images = [
  "/uploads/banner1.png",
  "/uploads/banner2.png",
  "/uploads/banner3.png",
  "/uploads/banner4.png",
  "/uploads/banner5.png",
  "/uploads/banner6.png",
  "/uploads/banner7.png",
  "/uploads/banner8.png",
];

const DashboardBanner = () => (
  <div className="container">
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={24}
      slidesPerView={4}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      breakpoints={{
        1200: { slidesPerView: 4 },
        900: { slidesPerView: 2 },
        0: { slidesPerView: 1 },
      }}
      className="dashboardbanner-swiper pb-0"
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx}>
          <div
            className="dashboardbanner-img-card"
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default DashboardBanner;